/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Partner_Admin_Commission_Attribution_WindowInputs */



/**
* | output |
* | --- |
* | "{from} — {to}" |
*
* @param {Partner_Admin_Commission_Attribution_WindowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_attribution_window = /** @type {((inputs: Partner_Admin_Commission_Attribution_WindowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Attribution_WindowInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.from} — ${i?.to}`)
	return /** @type {LocalizedString} */ (`${i?.from} — ${i?.to}`)
});